import axios from 'axios'

var config = {
    headers: {
        'Content-type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'cache-control': 'no-cache',
    }
};

var configFile = {
    headers: {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'cache-control': 'no-cache',
    }
};

export default ({
    forceRerender1(refPage) {
        refPage.renderComponent1 = false
        refPage.$nextTick(() => {
            refPage.renderComponent1 = true
        })
    },
    forceRerender2(refPage) {
        refPage.renderComponent2 = false
        refPage.$nextTick(() => {
            refPage.renderComponent2 = true
        })
    },
    forceRerender3(refPage) {
        refPage.renderComponent3 = false
        refPage.$nextTick(() => {
            refPage.renderComponent3 = true
        })
    },
    getProgramsListByOperator: function (endpoint, store, IdOperator, IdLevelForm) {
        axios.get(endpoint + 'Program/ListByOperator/' + IdOperator + '/' + IdLevelForm, config).then(
            Response => {
                store.length = 0;
                for (var i = 0; i < Response.data.length; i++) {
                    store.push({ id: Response.data[i].id, value: Response.data[i].nameProgram, requirePayment: Response.data[i].requirePayment })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getModalityListByProgram: function (endpoint, store, IdProgram, IdOperator) {
        axios.get(endpoint + 'Modality/ListByprogramByOperator/' + IdProgram + '/' + IdOperator, config).then(
            Response => {
                store.length = 0;
                for (var i = 0; i < Response.data.length; i++) {
                    store.push({ id: Response.data[i].id, value: Response.data[i].nameModality })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getWorkdayListByModality: function (endpoint, store, IdModality, IdProgram, IdOperator) {
        axios.get(endpoint + 'Workday/ListByModalityByProgramByOperator/' + IdModality + '/' + IdProgram + '/' + IdOperator, config).then(
            Response => {
                store.length = 0;
                for (var i = 0; i < Response.data.length; i++) {
                    store.push({ id: Response.data[i].id, value: Response.data[i].namWorkday })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getCitiesListByState: function (endpoint, store, idref) {
        axios.get(endpoint + 'City/ListByState/' + idref, config).then(
            Response => {
                store.length = 0;
                for (var i = 0; i < Response.data.length; i++) {
                    store.push({ id: Response.data[i].codeCity, value: Response.data[i].nameCity })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    GetEthnicityReference: function (endpoint, store, idref) {
        axios.get(endpoint + 'Ethnicity/GetEthnicityReference/' + idref, config).then(
            Response => {
                store.length = 0;
                for (var i = 0; i < Response.data.length; i++) {
                    store.push({ id: Response.data[i].idEthnicity, value: Response.data[i].namEthnicity })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getItemsListByPQRS: function (endpoint, store, idref) {

        axios.get(endpoint + 'PQRS/ListItemByPQRS/' + idref, config).then(
            Response => {
                store.length = 0;
                for (var i = 0; i < Response.data.length; i++) {
                    store.push({ id: Response.data[i].Id_ItemPQRS, value: Response.data[i].Nam_ItemPQRS })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getFilesByIdSubject: function (endpoint, idref) {
        return axios.get(endpoint + 'PQRS/ListFilesByItems/' + idref, config)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error("Error:", error);
                throw error;
            });
    },
    getStatesListByCountry: function (endpoint, store, idref) {
        axios.get(endpoint + 'State/ListByCountry/' + idref, config).then(
            Response => {
                store.length = 0;
                for (var i = 0; i < Response.data.length; i++) {
                    store.push({ id: Response.data[i].codeState, value: Response.data[i].nameState })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getDiplomas: async function (endpoint, store, sdocument, semail) {

        var InfData = {
            document: sdocument,
            email: semail,
        }

        var sresp;
        try {
            sresp = await axios.post(endpoint + 'Diplomas/', InfData, config)
        } catch (error) {
            sresp = "error"
            console.log(error)
        }
        return sresp
    },
    getStatusCase: async function (store, IdCase) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'StatusHistory/getStatusCase/' + IdCase)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }

        return this.availabilityMessage
    },
    getAttachmentCase: async function (store, IdCase) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Zoho/ZohoCaseFile/' + IdCase)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }

        return this.availabilityMessage
    },
    getAsesor: async function (endpoint, store, sdocument) {

        try {
            this.availabilityMessage = await axios.get(endpoint + 'Avaya/GetAdviserByDocument/' + sdocument)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }

        return this.availabilityMessage
    },
    getCountriesList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Countries/GetAllCountry/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.CountriesList.push({ id: Response.data[i].codeCountry, value: Response.data[i].nameCountry })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getBondsList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Bond/GetAllBonds', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.BondsList.push({ id: Response.data[i].Id_Bond, value: Response.data[i].Name_Bond })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getPQRSList: function (store) {

        axios.get(store.state.ApiIbero.WSParametric + 'PQRS/GetAllPQRSType', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.PQRSList.push({ id: Response.data[i].Id_PQRSType, value: Response.data[i].Nam_PQRSType })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getProgramsList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Program/GetProgramBanner', config).then(
            Response => {
                store.state.ProgramsList.length = 0;
                const seen = new Set();
                for (var i = 0; i < Response.data.length; i++) {
                    const id = Response.data[i].Hom_Banner;
                    if (!seen.has(id)) {
                        seen.add(id);
                        store.state.ProgramsList.push({ id, value: Response.data[i].Nam_Program });
                    }
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getAllCertificateType: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Certificate/GetTypeCertificate', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.CertificatesList.push({ id: Response.data[i].Id_Case_Zoho, value: Response.data[i].Name })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getModalitiesList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Modality/GetAllModality', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.ModalitiesList.push({ id: Response.data[i].homBanner, value: Response.data[i].namModality })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getDegreeList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Degree/GetAllDegreeIbero/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.DegreeList.push({ id: Response.data[i].idDegree, value: Response.data[i].namDegree, codVal: Response.data[i].codDegree })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })

        axios.get(store.state.ApiIbero.WSParametric + 'Degree/GetAllDegreeHomologation/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.HomDegreeList.push({ id: Response.data[i].idDegree, value: Response.data[i].namDegree })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })

    },

    getDegreeDocumentList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Degree/GetAllDegreeDocuments/', config).then(
            Response => {
                store.state.DegreeDocumentList = Response.data
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getDesabilityList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Desability/GetAllDesability/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.DesabilityList.push({ id: Response.data[i].idDesability, value: Response.data[i].namDesability })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getDocTypeList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'DocumentTypes/GetAllDocumentType', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.DocTypesList.push({ id: Response.data[i].idDocumentType, value: Response.data[i].nameDocumentType })
                    store.state.DocTypesListICFES.push({ id: Response.data[i].idDocumentType, value: Response.data[i].nameDocumentType })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getEPSList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Eps/GetEPSList/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.EPSList.push({ id: Response.data[i].Id_Eps, value: Response.data[i].Nam_Eps })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getEPSQAList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Eps/GetEPSQAList/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.EPSQAList.push({ id: Response.data[i].Id_EpsQuality, value: Response.data[i].Nam_EpsQuality })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getEthnicityList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Ethnicity/GetAllEthnicity/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.EthnicityList.push({ id: Response.data[i].idEthnicity, value: Response.data[i].namEthnicity })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getGenderList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Gender/GetAllGender/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.GenderList.push({ id: Response.data[i].idGender, value: Response.data[i].namGender })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getEPSList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Eps/GetEPSList/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.EPSList.push({ id: Response.data[i].Id_Eps, value: Response.data[i].Nam_Eps })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getEPSQAList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Eps/GetEPSQAList/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.EPSQAList.push({ id: Response.data[i].Id_EpsQuality, value: Response.data[i].Nam_EpsQuality })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getMaritalStatusList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'MaritalStatus/GetAllMaritalStatus/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.MaritalStatusList.push({ id: Response.data[i].idMaritalStatus, value: Response.data[i].namMaritalStatus })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getOperatorList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Operator/GetAllOperator/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.OperatorList.push({ id: Response.data[i].idOperator, value: Response.data[i].namOperator })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getPeriodList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Period/GetAllPeriod/', config).then(
            Response => {
                var now = new Date().toISOString().slice(0, 10);
                for (var i = 0; i < Response.data.length; i++) {
                    if (Response.data[i].datEndDate.slice(0, 10) > now) {
                        store.state.PeriodoList.push({ id: Response.data[i].idPeriod, value: Response.data[i].desPeriod })
                    }
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getStateList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'State/GetListState/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.StateList.push({ id: Response.data[i].codeState, value: Response.data[i].nameState })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getWorkdaySchoolList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Workday/GetListWorkday/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.JornadaList.push({ id: Response.data[i].id, value: Response.data[i].namWorkday })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getWorkdayList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'Workday/GetListWorkday/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.WorkdayList.push({ id: Response.data[i].namWorkday, value: Response.data[i].namWorkday })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    getSchoolTypeList: function (store) {
        axios.get(store.state.ApiIbero.WSParametric + 'SchoolType/GetAllSchoolType/', config).then(
            Response => {
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.TipocColegioList.push({ id: Response.data[i].idSchoolType, value: Response.data[i].namSchoolType })
                }
            }
        ).catch(e => function (e) {
            console.log(e);
        })
    },
    dataObjFind: function (infoDaT, FinDaT) {
        if (infoDaT != '' || FinDaT != '') {
            var valuefin = infoDaT.find(element => element.id == FinDaT);
            if (valuefin !== undefined) {
                return valuefin.value;
            } else {
                return '';
            }
        }
        return FinDaT;
    },
    dataObjAllFind: function (infoDaT, FinDaT) {
        if (infoDaT != '' || FinDaT != '') {
            var valuefin = infoDaT.find(element => element.id == FinDaT);
            if (valuefin !== undefined) {
                return valuefin;
            }
        }
        return FinDaT;
    },
    ValuedataObjFind: function (infoDaT, FinDaT) {
        if (infoDaT != '' || FinDaT != '') {
            var valuefin = infoDaT.find(element => element.value === FinDaT);
            if (valuefin !== undefined) {
                return valuefin.id;
            }
        }
        return FinDaT;
    },
    sendDataLog: function (store, datainf) {
        var InfData = {
            idUser: 1,
            date: new Date(),
            movementType: 'API/LoginPES',
            method: 'POST',
            ip: datainf.ipaddr,
            request: datainf.upn,
            response: JSON.stringify(datainf),
        }
        axios.post(store.state.ApiIbero.WSAudit + 'Logs/', InfData, config).catch(e => function (e) {
            console.log(e)
        })
    },
    getRegistrationPayOrder: async function (endpoint, idDocument, desPeriod) {
        try {
            this.availabilityMessage = await axios.get(endpoint + 'Inscription/GetRegistrationPayOrder/' + idDocument + '/' + desPeriod)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    postPayOrderInscripcionOMA: async function (store, datainf) {
        try {
            var InfData = {
                periodo: this.dataObjFind(store.state.PeriodoList, datainf.IdConvoca).split(' ')[0],
                tipo_identificacion: datainf.IdDocType,
                identificacion: datainf.IdDocument,
                primer_nombre: datainf.IdNombreP.trim(),
                segundo_Nombre: datainf.IdNombreS.trim(),
                primer_apellido: datainf.IdApellidosP.trim(),
                segundo_apellido: datainf.IdApellidosS.trim(),
                direccion: datainf.IdAddress,
                telefono: datainf.IdHomePhone,
                genero: this.dataObjFind(store.state.GenderList, datainf.IdGender),
                estado_civil: this.dataObjFind(store.state.MaritalStatusList, datainf.IdCivilState),
                email: datainf.IdMail,
                fecha_nacimiento: datainf.IdDaySelectBirth + "/" + datainf.IdMonthSelectBirth + "/" + datainf.IdYearSelectBirth,
                celular: datainf.IdCelPhone,
                pais: datainf.IdNacionality,
                departamento: datainf.IdStateRes,
                poblacion: datainf.IdCityRes,
                cod_programa: datainf.IdInteProgram,
                origen: 'Campus',
            };
            this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Inscription/CreateOrderOMA/', InfData, config);
        } catch (error) {
            this.availabilityMessage = false;
            console.log(error);
        };
        return this.availabilityMessage;
    },
    getPayOrder: async function (endpoint, NumDocument, IdPeriod) {
        try {
            this.availabilityMessage = await axios.get(endpoint + 'Inscription/GetPayOrder/' + NumDocument + '/' + IdPeriod)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    getUserLogin: async function (store, mail) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/ListPersonByEmail/' + mail + '/1', config)

        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    getOperatorByName: async function (store, opera) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSParametric + 'Operator/GetOperatorByName/' + opera, config)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    addVotoUser: async function (store, iduser, listVoto) {
        try {
            var InfData = {
                idRange: parseInt(listVoto.refVoto),
                idPerson: parseInt(iduser),
                idVotoStudent: (listVoto.student != '') ? parseInt(listVoto.student) : 0,
                idVotoTeacher: (listVoto.teacher != '') ? parseInt(listVoto.teacher) : 0,
            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Voting/AddVotingUser/', InfData, config)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    listVotingUser: async function (store, iduser) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Voting/GetVotingUser/' + iduser)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    listVotingRange: async function (store) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Voting/GetVotingRange/1/')
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    findUserInscription: async function (store, datainf) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Inscription/GetSignUpPersonByZoho/' + datainf.IdDocType + '/' + datainf.IdDocument)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    findContactByZoho: async function (store, datainf, valida) {
        try {

            if (datainf.IdDocument == null || datainf.IdDocument == "") {
                datainf.IdDocument = '0';
            }
            if (datainf.IdCelPhone == null || datainf.IdCelPhone == "") {
                datainf.IdCelPhone = '0';
            }
            if (datainf.IdMail == null || datainf.IdMail == "") {
                datainf.IdMail = '0';
            }

            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Inscription/GetFind_ContactByZoho/' + datainf.IdDocument + '/' + datainf.IdCelPhone + '/3009765/' + datainf.IdMail + '/' + valida)

            if (valida == "identificationNumber" && this.availabilityMessage.data == "True") {
                alert("El documento de Identidad ingresado ya existe en nuestra base de datos, valide si el aspirante ya tiene una matricula activa en uno de nuestros programas, de no ser así pulse en siguiente.");
            }

            if (valida == "mobile" && this.availabilityMessage.data == "True") {
                alert("El número de teléfono ingresado ya existe en nuestra base de datos, valide si el aspirante ya tiene una matricula activa en uno de nuestros programas, de no ser así pulse en siguiente.");
            }

            if (valida == "email" && this.availabilityMessage.data == "True") {
                alert("El correo ingresado ya existe en nuestra base de datos, valide si el aspirante ya tiene una matricula activa en uno de nuestros programas, de no ser así pulse en siguiente.");
            }

        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    findUserBanner: async function (store, datainf) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/ListPersonByDocumentAndType/' + datainf.IdDocType + '/' + datainf.IdDocument)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },

    findGraduatedData: async function (store, datainf) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/GetGraduatedBanner/' + datainf.IdDocument + '/' + datainf.IdDaySelect + '-' + datainf.IdMonthSelect + '-' + datainf.IdYearSelect)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },

    findUserBannerComplete: async function (store, datainf) {
        try {
            var tipoDocumento = this.dataObjFind(store.state.DocTypesList, datainf.IdDocType);

            switch (tipoDocumento) {
                case "Cédula de ciudadanía":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/GetBannerByDocumentAndType/CC/' + datainf.IdDocument)
                    break;
                case "Tarjeta de identidad":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/GetBannerByDocumentAndType/TI/' + datainf.IdDocument)
                    break;
                case "Cédula de extranjería":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/GetBannerByDocumentAndType/CE/' + datainf.IdDocument)
                    break;
                case "Pasaporte":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/GetBannerByDocumentAndType/PS/' + datainf.IdDocument)
                    break;
                case "Certificado cabildo":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Person/GetBannerByDocumentAndType/CA/' + datainf.IdDocument)
                    break;
            }
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }

        return this.availabilityMessage
    },
    findStudentCertificate: async function (store, datainf) {
        try {
            var tipoDocumento = this.dataObjFind(store.state.DocTypesList, datainf.IdDocumentType);

            switch (tipoDocumento) {
                case "Cédula de ciudadanía":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/InformationStudent/CC/' + datainf.IdDocument)
                    break;
                case "Tarjeta de identidad":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/InformationStudent/TI/' + datainf.IdDocument)
                    break;
                case "Cédula de extranjería":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/InformationStudent/CE/' + datainf.IdDocument)
                    break;
                case "Pasaporte":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/InformationStudent/PS/' + datainf.IdDocument)
                    break;
                case "Certificado cabildo":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/InformationStudent/CA/' + datainf.IdDocument)
                    break;
            }
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },

    findStudentProgramsCertificate: async function (store, datainf) {
        try {
            const tipoDocumentoTxt = this.dataObjFind(store.state.DocTypesList, datainf.IdDocumentType);

            let sigla = "";
            switch (tipoDocumentoTxt) {
                case "Cédula de ciudadanía": sigla = "CC"; break;
                case "Tarjeta de identidad": sigla = "TI"; break;
                case "Cédula de extranjería": sigla = "CE"; break;
                case "Pasaporte": sigla = "PS"; break;
                case "Certificado cabildo": sigla = "CA"; break;
                default: sigla = "CC"; break;
            }
            return await axios.get(
                store.state.ApiIbero.WSUtilitary +
                "Certificate/InformationStudentProgram/" +
                sigla +
                "/" +
                datainf.IdDocument
            );
        } catch (error) {
            console.log(error);
            return false;
        }
    },


    findStudentPeriodsCertificate: async function (store, datainf) {
        try {
            const tipoDocumentoTxt = this.dataObjFind(store.state.DocTypesList, datainf.IdDocumentType);

            let sigla = "";
            switch (tipoDocumentoTxt) {
                case "Cédula de ciudadanía": sigla = "CC"; break;
                case "Tarjeta de identidad": sigla = "TI"; break;
                case "Cédula de extranjería": sigla = "CE"; break;
                case "Pasaporte": sigla = "PS"; break;
                case "Certificado cabildo": sigla = "CA"; break;
                default: sigla = "CC"; break;
            }

            return await axios.get(
                store.state.ApiIbero.WSUtilitary +
                "Certificate/InformationStudentPeriod/" +
                sigla + "/" +
                datainf.IdDocument + "/" +
                datainf.IdProgram
            );
        } catch (error) {
            console.log(error);
            return false;
        }
    },

    findStudentHomologationCertificate: async function (store, datainf) {
        try {
            return await axios.get(
                store.state.ApiIbero.WSUtilitary +
                'Certificate/InformationPersonHomologation/' +
                datainf.IdBanner + '/' +
                datainf.IdPeriod,
                config
            );
        } catch (error) {
            console.log(error);
            return false;
        }
    },


    findStudentZafiro: async function (store, datainf) {
        try {
            var tipoDocumento = this.dataObjFind(store.state.DocTypesList, datainf.IdDocumentType);

            switch (tipoDocumento) {
                case "Cédula de ciudadanía":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/InformationStudent/CC/' + datainf.IdDocument)
                    break;
                case "Tarjeta de identidad":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/InformationStudent/TI/' + datainf.IdDocument)
                    break;
                case "Cédula de extranjería":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/InformationStudent/CE/' + datainf.IdDocument)
                    break;
                case "Pasaporte":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/InformationStudent/PS/' + datainf.IdDocument)
                    break;
                case "Certificado cabildo":
                    this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/InformationStudent/CA/' + datainf.IdDocument)
                    break;
            }
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }

        return this.availabilityMessage
    },
    findCase: async function (store, datainf) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'Certificate/CaseInformation/' + datainf.IdCase);
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    getUserInscription: async function (store, datauser) {
        try {
            var InfData = {
                idDocumentType: datauser.IdDocType,
                numDocument: datauser.IdDocument,
                desContactInformationMobile: datauser.IdCelPhone,
                desContactInformationEmail: datauser.IdMail,
            }
            this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Inscription/GetSignUpPerson/', InfData, config)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    getPeriodListByWorkDay: async function (endpoint, IdWorkDay, IdModality, IdProgram, IdTypeIncome) {
        try {
            if (IdTypeIncome == 'N') {
                this.availabilityMessage = await axios.get(endpoint + 'Period/LisPeriod/' + IdWorkDay + '/' + IdModality + '/' + IdProgram + '/' + 'Primer Ingreso', config)
            } else {
                this.availabilityMessage = await axios.get(endpoint + 'Period/LisPeriod/' + IdWorkDay + '/' + IdModality + '/' + IdProgram + '/' + 'Homologante', config)
            }
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }

        return this.availabilityMessage
    },
    getPlanListByWorkDay: async function (endpoint, IdWorkDay, IdModality, IdProgram, IdTypeIncome) {
        try {
            if (IdTypeIncome == 'N') {
                this.availabilityMessage = await axios.get(endpoint + 'Period/LisPlan/' + IdWorkDay + '/' + IdModality + '/' + IdProgram + '/' + 'Primer Ingreso', config)
            } else {
                this.availabilityMessage = await axios.get(endpoint + 'Period/LisPlan/' + IdWorkDay + '/' + IdModality + '/' + IdProgram + '/' + 'Homologante', config)
            }
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }

        return this.availabilityMessage
    },
    sendFilesByPerson: async function (store, objData) {
        try {
            var InfData = {
                listDoc: objData
            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Inscription/AddDocumentPerson/', InfData, config);
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    sendFilesByPQRS: async function (store, objData) {
        try {
            var InfData = {
                idSignUpPersonDetail: idFileRef,
                dataZoho: objData
            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddFilePQRS/', InfData, config);
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    sendFilesByPersonZoho: async function (store, objData, idFileRef) {
        try {
            var InfData = {
                idSignUpPersonDetail: idFileRef,
                dataZoho: objData
            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Inscription/AddDocumentPersonByZoho/', InfData, config);
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    sendFilesByPQRSZoho: async function (store, objData, idFileRef) {
        try {
            var InfData = {
                idSendPQRSDetail: idFileRef,
                dataZoho: objData
            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddFilePQRS/', InfData, config);
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    sendFilesCaseCertificate: async function (store, dataInf) {
        try {
            var InfData = {
                idCase: dataInf.idCase,
                typeIdentification: dataInf.typeIdentification,
                Identification: dataInf.Identification,
                Name: dataInf.Name,
                LastName: dataInf.LastName,
                IdBanner: dataInf.IdBanner,
                Email: dataInf.Email,
                Program: dataInf.Program,
                TypeCertificate: dataInf.TypeCertificate,
                Period: dataInf.Period,
                FileDetail: dataInf.FileDetail,
                TypeSend: dataInf.TypeSend
            }
            this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Certificate/AddFileCertificate/', InfData, config);
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    sendFileCases: async function (store, objData, idFileRef) {
        try {
            var InfData = {
                idCase: idFileRef,
                dataZoho: objData
            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Cases/AddFileCase/', InfData, config);
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    createInfoPDFByProcedure: async function (store, reference, codPDF, objData) {

        try {
            var infoPDF = {
                reference: reference,
                codPdf: codPDF,
                dataProcedure: objData
            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', infoPDF, config);
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    deleteFilesByPerson: async function (store, objData, uriDetail) {
        try {
            var InfData = {
                listDoc: objData,
                detailURI: uriDetail
            }
            this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Inscription/DeleteDocumentPerson/', InfData, config);
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        }
        return this.availabilityMessage
    },
    sendFormInscription: async function (store, datainf, dataAddres) {
        try {
            if (datainf.IdEtniaRef != 0) {
                datainf.IdEtnia = datainf.IdEtniaRef;
            }

            if (datainf.IdYearTitu === undefined) {
                datainf.IdYearTitu = '';
            }

            if (datainf.CodDepartmentSchool === undefined) {
                datainf.CodDepartmentSchool = '';
            }

            if (datainf.CodCitySchool === undefined) {
                datainf.CodCitySchool = '';
            }

            if (datainf.IdCityCol === undefined) {
                datainf.IdCityCol = '';
            }

            if (datainf.IdJornadaEsc === undefined) {
                datainf.IdJornadaEsc = '';
            }

            if (datainf.IdNumRegICFES === undefined) {
                datainf.IdNumRegICFES = '';
            }

            if (datainf.IdNumRegYearICFES === undefined) {
                datainf.IdNumRegYearICFES = '';
            }

            if (datainf.IdDocTypeICFES === undefined) {
                datainf.IdDocTypeICFES = '';
            }

            if (datainf.IdNumICFE === undefined) {
                datainf.IdNumICFE = '';
            }

            var InfData = {
                idOperator: '' + datainf.IdOperator,
                idLevel: datainf.IdLevelForm,
                idDocumentType: datainf.IdDocType,
                nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                numDocument: datainf.IdDocument,
                doc_ExpeditionDate: datainf.IdDaySelect + "/" + datainf.IdMonthSelect + "/" + datainf.IdYearSelect,

                codExpeditionDepartment: datainf.IdState,
                nameExpeditionDepartment: this.dataObjFind(store.state.StateList, datainf.IdState),
                codExpeditionCity: datainf.IdCity,
                nameExpeditionCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                namPerson: datainf.IdNombreP.trim() + ' ' + datainf.IdNombreS.trim(),
                lastNamePerson: datainf.IdApellidosP.trim() + ' ' + datainf.IdApellidosS.trim(),
                resAddress: datainf.IdAddress,

                resAddressZone: dataAddres.IdAddressList,
                resAddressStreet: dataAddres.IdAddressStreet,
                resAddressNumber: dataAddres.IdAddressNum,
                resAddressReference: dataAddres.IdAddressRef,
                resAddressAditional: dataAddres.IdAddressExtra,

                resNeighborhood: 'BRR ' + datainf.IdNeighbor,
                codResidenceDepartment: datainf.IdStateRes,
                nameResidenceDepartment: this.dataObjFind(store.state.StateList, datainf.IdStateRes),
                codResidenceCity: datainf.IdCityRes,
                nameResidenceCity: this.dataObjFind(store.state.CityListRes, datainf.IdCityRes),
                codNationality: datainf.IdNacionality,
                nameNationality: this.dataObjFind(store.state.CountriesList, datainf.IdNacionality),
                codBirthDepartment: datainf.IdStateBirth,
                nameBirthDepartment: this.dataObjFind(store.state.StateList, datainf.IdStateBirth),
                codBirthCity: datainf.IdCityBirth,
                nameBirthCity: this.dataObjFind(store.state.CityListBirth, datainf.IdCityBirth),

                birthDate: datainf.IdDaySelectBirth + "/" + datainf.IdMonthSelectBirth + "/" + datainf.IdYearSelectBirth,
                idGender: datainf.IdGender,
                nameGender: this.dataObjFind(store.state.GenderList, datainf.IdGender),
                idEthnicity: datainf.IdEtnia,
                nameEthnicity: this.dataObjFind(store.state.EthnicityList, datainf.IdEtnia),
                idLeyveteranos: datainf.IdLeyVete,
                idDesability: datainf.IdDiscapa,
                nameDesability: this.dataObjFind(store.state.DesabilityList, datainf.IdDiscapa),
                idMaritalStatus: datainf.IdCivilState,
                nameMaritalStatus: this.dataObjFind(store.state.MaritalStatusList, datainf.IdCivilState),
                idEPS: '' + datainf.IdEPS,
                idEPSQA: '' + datainf.IdEPSQA,
                IdEstrato: datainf.IdEstrato,
                termsConditions: datainf.IdTermiCondi,
                idContactTypePhone: 1,
                desContactInformationPhone: datainf.IdHomePhone,
                idContactTypeMobile: 2,
                desContactInformationMobile: datainf.IdCelPhone,
                idContactTypeEmail: 3,
                desContactInformationEmail: datainf.IdMail,

                idContactTypeNameEmergency: 5,
                desContactInformationNameEmergency: datainf.IdContactName,
                idContactTypePhoneEmergency: 4,
                desContactInformationPhoneEmergency: datainf.IdContactPhone,

                desContactInformationContactCity: datainf.IdContactCity,
                desContactInformationContactAdres: datainf.IdContactAdres,
                DesContactInformationWork: datainf.IdWork,
                DesContactInformationPersons: datainf.IdPersons,
                DesContactInformationMaterial: datainf.IdMaterial,

                idKinship: 1,
                famName: datainf.IdNombreP,
                famLastName: datainf.IdApellidosP,
                numPhone: datainf.IdHomePhone,
                numCellPhone: datainf.IdCelPhone,
                famAddress: datainf.IdAddress,
                fam_Email: datainf.IdMail,
                valIncomeMonthly: 1,
                valExpenseMonthly: 1,
                valOtherIncome: 1,
                desOtherIncome: "",
                comName: datainf.IdNombreP,
                com_Address: datainf.IdAddress,
                comPhoneNumber: datainf.IdHomePhone,
                comEmail: datainf.IdMail,
                valSalary: 1,
                idSchoolType: (datainf.IdTypeColegio === '') ? 0 : datainf.IdTypeColegio,
                nameSchoolType: this.dataObjFind(store.state.TipocColegioList, datainf.IdTypeColegio),
                namSchool: datainf.IdColegio,
                TitlePregrado: datainf.TituloPregrado,
                codDepartmentSchool: datainf.IdStateCol,
                nameDepartmentSchool: this.dataObjFind(store.state.StateList, datainf.IdStateCol),
                codCitySchool: datainf.IdCityCol,
                nameCitySchool: this.dataObjFind(store.state.CityListCol, datainf.IdCityCol),
                idWorkdaySchool: (datainf.IdJornadaEsc === '') ? 0 : datainf.IdJornadaEsc,
                nameWorkdaySchool: this.dataObjFind(store.state.JornadaList, datainf.IdJornadaEsc),
                DateEndSchool: datainf.IdDaySelectCol + "/" + datainf.IdMonthSelectCol + "/" + datainf.IdYearSelectCol,
                icfesRegistrationNumber: datainf.IdNumRegICFES,
                icfesYear: datainf.IdNumRegYearICFES,
                icfesIdentificationType: '' + datainf.IdDocTypeICFES,
                icfesIdentificationNumber: datainf.IdNumICFES,

                typeIncome: datainf.IdTypeIncome,
                idProgram: datainf.IdInteProgram,
                nameProgram: this.dataObjFind(store.state.ProgramList, datainf.IdInteProgram),
                idModality: datainf.IdModalidad,
                nameModality: this.dataObjFind(store.state.ModalityList, datainf.IdModalidad),
                idWorkday: datainf.IdJornada,
                nameWorkday: this.dataObjFind(store.state.JornadaList, datainf.IdJornada),
                idPeriod: datainf.IdConvoca,
                namePeriod: this.dataObjFind(store.state.PeriodoList, datainf.IdConvoca).split(' ')[0],
                deepening: datainf.IdDeepening,
                IdFaculty: "",
                reqHomologation: datainf.IdHomolo,
                idHomLevelStudy: datainf.IdNivelEstu,
                nameHomLevelStudy: this.dataObjFind(store.state.DegreeList, datainf.IdNivelEstu),
                homEducationInstitution: datainf.IdInstiEdu,
                homObtainedTitle: datainf.IdTitulo,
                homGraduationYear: '' + datainf.IdYearTitu,
                idCreateBy: 1,
                idUpdatedBy: 1,
                checkMatricula: datainf.IdComproMatricula,
                IdPlan: "" + datainf.IdPlan,
            };
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Inscription/AddDealsPersonByZoho/', InfData, config);
        } catch (error) {
            this.availabilityMessage = false;
            console.log(error);
        };
        return this.availabilityMessage;
    },
    sendFormPQRS: async function (store, datainf) {
        try {
            var asunto = this.dataObjFind(store.state.ItemList, datainf.IdSubject);
            var requerimiento = this.dataObjFind(store.state.PQRSList, datainf.IdPQRS);
            if (asunto != "OTRO" && requerimiento != "Trámite") {
                var InfData = {
                    idDocumentType: datainf.IdDocType,
                    nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                    numDocument: datainf.IdDocument,
                    namPerson: datainf.IdNombres,
                    lastNamePerson: datainf.IdApellidosS,
                    idBanner: datainf.IdBanner,
                    desContactInformationPhone: datainf.IdHomePhone,
                    desContactInformationMobile: datainf.IdCelPhone,
                    desContactInformationEmail: datainf.IdMail,
                    nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                    nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                    nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                    idBond: datainf.IdBond,
                    nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                    idPQRS: '' + datainf.IdPQRS,
                    pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                    idSubject: '' + datainf.IdSubject,
                    subject: this.dataObjFind(store.state.ItemList, datainf.IdSubject),
                    description: datainf.Description,
                    feedback: datainf.Feedback,
                    nameFile: datainf.IdFile,
                    termsConditions: datainf.IdTermiCondi,
                };
                this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
            } else if (asunto === "OTRO") {
                var InfData = {
                    idDocumentType: datainf.IdDocType,
                    nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                    numDocument: datainf.IdDocument,
                    namPerson: datainf.IdNombres,
                    lastNamePerson: datainf.IdApellidosS,
                    idBanner: datainf.IdBanner,
                    desContactInformationPhone: datainf.IdHomePhone,
                    desContactInformationMobile: datainf.IdCelPhone,
                    desContactInformationEmail: datainf.IdMail,
                    nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                    nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                    nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                    idBond: datainf.IdBond,
                    nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                    idPQRS: '' + datainf.IdPQRS,
                    pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                    idSubject: '' + datainf.IdSubject,
                    subject: datainf.Subject,
                    description: datainf.Description,
                    feedback: datainf.Feedback,
                    nameFile: datainf.IdFile,
                    termsConditions: datainf.IdTermiCondi,
                };
                this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
            } else if (requerimiento === "Trámite") {
                var peticion = this.dataObjFind(store.state.ItemList, datainf.IdSubject);
                switch (peticion) {
                    case "CAMBIO DE JORNADA":
                        var itemPQRS = "3229357000002965763";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "CAMBIO DE MODALIDAD":

                        var itemPQRS = "3229357000002965769";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "CAMBIO DE PROGRAMA":

                        var itemPQRS = "3229357000002965769";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "CARGA COMPLETA":

                        var itemPQRS = "3229357000009313079";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "MEDIA CARGA":

                        var itemPQRS = "3229357000009313079";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "CUARTO DE CARGA":

                        var itemPQRS = "3229357000009313079";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "CRÉDITOS ADICIONALES":

                        var itemPQRS = "3229357000011778131";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "APLAZAMIENTO DE PERIODO ACADÉMICO":

                        var itemPQRS = "3229357000235792328";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;

                    case "CANCELACIÓN DE PERIODO ACADÉMICO":

                        var itemPQRS = "3229357000235792328";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "SOLICITUD DE GRADO POR VENTANILLA":
                        var itemPQRS = "3229357000009313108";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "REINGRESO":
                        var itemPQRS = "3229357000002965503";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "REINGRESO CON CAMBIO DE PROGRAMA":

                        var itemPQRS = "3229357000002965769";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "RECUPERO":

                        var itemPQRS = "3229357000115783681";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "SOLICITUD DE REVISIÓN DE ESTUDIO DE HOMOLOGACIÓN":

                        var itemPQRS = "3229357000015127998";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "VERIFICACIÓN DE HISTORIAL ACADÉMICO":

                        var itemPQRS = "3229357000002965473";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "TRASLADO DE OPERADOR":

                        var itemPQRS = "3229357000002965961";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "SALDO A FAVOR Y/O DEVOLUCIÓN DE DINERO":

                        var itemPQRS = "3229357000009313105";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "MATRÍCULA DE HONOR – DEVOLUCIÓN Y/O ABONO DE DINERO":

                        var itemPQRS = "3229357000009313099";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "APROBACIÓN DE DOBLE PROGRAMA DE PREGRADO":

                        var itemPQRS = "3229357000002965497";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                    case "CONVALIDACIÓN DE TÍTULOS EN EL EXTERIOR":
                        var itemPQRS = "3229357002591763284";
                        var InfData = {
                            idDocumentType: datainf.IdDocType,
                            nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                            numDocument: datainf.IdDocument,
                            namPerson: datainf.IdNombres,
                            lastNamePerson: datainf.IdApellidosS,
                            idBanner: datainf.IdBanner,
                            desContactInformationPhone: datainf.IdHomePhone,
                            desContactInformationMobile: datainf.IdCelPhone,
                            desContactInformationEmail: datainf.IdMail,
                            nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                            nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                            nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                            idBond: datainf.IdBond,
                            nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
                            idPQRS: '' + datainf.IdPQRS,
                            pqrs: this.dataObjFind(store.state.PQRSList, datainf.IdPQRS),
                            idSubject: '' + datainf.IdSubject,
                            subject: itemPQRS,
                            otherSubject: datainf.Subject,
                            description: datainf.Description,
                            feedback: datainf.Feedback,
                            nameFile: datainf.IdFile,
                            termsConditions: datainf.IdTermiCondi,
                        };

                        this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/AddPQRSByCampus/', InfData, config);
                        break;
                }
            }
        } catch (error) {
            this.availabilityMessage = false;
            console.log(error);
        };
        return this.availabilityMessage;
    },
    sendCaseZoho: async function (store, datainf) {
        try {
            var infData = {
                firstName: datainf.IdName,
                lastName: datainf.IdLastname,
                mobile: datainf.Mobile,
                email: datainf.Email,
                identificationNumber: datainf.Document,
                bannerID: datainf.IdBanner,
                subject: datainf.IdRequest,
                reason: datainf.IdRequest,
                requestType: datainf.IdRequest,
                message: datainf.Message,
                nameFile: datainf.IdFile,
            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Cases/CreateCase/', infData, config)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        };
        return this.availabilityMessage
    },
    sendFormUpdateGraduated: async function (store, datainf) {
        try {
            var InfData = {
                idPerson: datainf.IdPerson,
                idBanner: datainf.IdBanner,
                idDocumentType: 1,
                nameDocumentType: 'Cédula de ciudadanía',
                numDocument: datainf.IdDocument,
                namPerson: datainf.IdNombres,
                lastNamePerson: datainf.IdApellidos,
                resAddress: datainf.IdDireccion,
                codResidenceDepartment: datainf.IdState,
                nameResidenceDepartment: this.dataObjFind(store.state.StateList, datainf.IdState),
                codResidenceCity: datainf.IdCity,
                nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                idUpdatedBy: datainf.IdDocument,
                nameResidenceNeighborhood: datainf.IdDireccion,
                termsConditions: datainf.IdTermiCondi,
                infReceive: 1,
                idContactTypePhone: 1,
                desContactInformationPhone: datainf.IdHomePhone,
                idContactTypePhoneEmergency: 4,
                desContactInformationPhoneEmergency: datainf.IdCelPhone,
                idContactTypeMobile: 2,
                desContactInformationMobile: datainf.IdCelPhone,
                idContactTypeEmail: 3,
                desContactInformationEmail: datainf.IdCorreo,
                idPersonOperator: 0,
                idOperator: 0,
                observation: 'Actualización de datos realizada desde el módulo de egresados en Campus',
                staActive: true,
            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Person/UpdatePerson/', InfData, config)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        };
        return this.availabilityMessage
    },
    sendCaseCertificate: async function (store, datainf) {
        try {
            const explicitPrice = Number(datainf.PriceCertificate);
            let quantityPeriod;
            let price;
            let observation;
            let practiceData;
            if (!Number.isNaN(explicitPrice) && explicitPrice >= 0) {
                quantityPeriod = datainf.IdQuantity > 0 ? datainf.IdQuantity : 1;
                price = explicitPrice;
            } else if (datainf.IdQuantity > 0) {
                quantityPeriod = datainf.IdQuantity;
                price = datainf.IdQuantity * 24575;
            } else {
                quantityPeriod = 1;
                if (datainf.IdCertificateType == '3229357002292608390') {
                    price = 0;
                } else {
                    price = 24575;
                }
            }
            if (datainf.IdObservation != '') {
                observation = datainf.IdObservation;
            } else {
                observation = 'Esto fue creado desde el formulario de Solicitud de Certificados';
            }
            if (datainf.IdPractice != '') {
                practiceData = datainf.IdPractice;
            } else {
                practiceData = '';
            }
            const infData = {
                namPerson: datainf.IdNombres,
                lastNamePerson: datainf.IdApellidos,
                idDocumentType: '' + datainf.IdDocumentType,
                numDocument: datainf.IdDocument,
                idBanner: datainf.IdBanner,
                phone: datainf.IdCellphone,
                person_Email: datainf.IdMail,
                person_University: (datainf.IdIberoMail && String(datainf.IdIberoMail).trim() !== '')
                    ? String(datainf.IdIberoMail).trim()
                    : 'No tiene',

                codProgram: datainf.IdProgram,
                program: this.dataObjFind(store.state.ProgramsList, datainf.IdProgram),
                modality: this.dataObjFind(store.state.ModalitiesList, datainf.IdModality),
                codWorkDay: datainf.IdWorking,
                workDay: this.dataObjFind(store.state.WorkdayList, datainf.IdWorking),
                codTypeCertificate: datainf.IdCertificateType,
                typeCertificate: this.dataObjFind(store.state.CertificatesList, datainf.IdCertificateType),

                periodCertificate: datainf.IdPeriod,
                periodCount: '' + quantityPeriod,
                practice: practiceData,
                typeSend: datainf.IdSendType,
                message: observation,
                priceCertificate: '' + price,
            }
            const CERT_NOTAS = "Certificado de Notas (Materias créditos y promedio semestral y general)";
            const isNotas = infData.typeCertificate === CERT_NOTAS;
            const useLegacyNotasFlow = !!datainf.UseLegacyFlowNotas;
            if (isNotas && !useLegacyNotasFlow) {
                infData.isHomologation = !!datainf.IsHomologation;
                infData.isCurPeriod = !!datainf.IsCurPeriod;
            }
            if (isNotas && !useLegacyNotasFlow) {
                this.availabilityMessage = await axios.put(
                    store.state.ApiIbero.WSUtilitary + 'Certificate/CreateRegCertificate',
                    infData,
                    config
                )
            } else {
                this.availabilityMessage = await axios.put(
                    store.state.ApiIbero.WSUtilitary + 'Certificate/CreateCaseZoho',
                    infData,
                    config
                )
            }

        } catch (error) {
            this.availabilityMessage = error.response || false
            console.log(error)
        }

        return this.availabilityMessage
    },


    sendCaseResetPassZafiro: async function (store, datainf) {
        try {
            var quantityPeriod;
            var price;
            var observation;
            var practiceData;

            if (datainf.IdObservation != '') {
                observation = datainf.IdObservation;
            } else {
                observation = 'Esto fue creado desde el formulario de Reestablecimiento de Contraseña Zafiro';
            }

            var infData = {
                firstName: datainf.IdNombres,
                lastName: datainf.IdApellidos,
                mobile: datainf.IdCellphone,
                email: datainf.IdIberoMail,
                identificationNumber: datainf.IdDocument,
                bannerID: datainf.IdBanner,
                subject: 'INCONVENIENTES PARA INGRESAR A ZAFIRO',
                message: observation,
                caseType: 'Solicitud',
                reason: '3229357000009313092',
                status: 'Nuevo',
                priority: 'Alto',
                caseOrigin: 'Web',

            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Zafiro/CreateCaseZohoResetPassword', infData, config)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        };
        return this.availabilityMessage
    },
    sendGenerationPDF: async function (store, refFrom, refPDF, datainf) {
        try {
            var today = new Date();
            var tipoTramite = this.dataObjFind(store.state.ItemList, datainf.IdSubject);
            switch (tipoTramite) {
                case "CAMBIO DE JORNADA":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: 'X',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: 'X',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: 'X',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: 'X',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "CAMBIO DE MODALIDAD":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: 'X',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: 'X',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: 'X',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: 'X',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "CAMBIO DE PROGRAMA":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: 'X',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: 'X',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: 'X',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: 'X',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "CARGA COMPLETA":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: 'X',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: 'X',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: 'X',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: 'X',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "MEDIA CARGA":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: 'X',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: 'X',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: 'X',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: 'X',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "CUARTO DE CARGA":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: 'X',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: 'X',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: 'X',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: 'X',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "CRÉDITOS ADICIONALES":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: 'X',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: 'X',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: 'X',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: 'X',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "APLAZAMIENTO DE PERIODO ACADÉMICO":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: 'X',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: 'X',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: 'X',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: 'X',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;

                case "CANCELACIÓN DE PERIODO ACADÉMICO":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: 'X',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: 'X',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: 'X',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: 'X',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "SOLICITUD DE GRADO POR VENTANILLA":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: 'X',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: 'X',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: 'X',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: 'X',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "REINGRESO":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: 'X',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: 'X',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: 'X',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: 'X',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "REINGRESO CON CAMBIO DE PROGRAMA":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: 'X',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: 'X',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: 'X',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: 'X',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "RECUPERO":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: 'X',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: 'X',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: 'X',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: 'X',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "SOLICITUD DE REVISIÓN DE ESTUDIO DE HOMOLOGACIÓN":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: '  ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: 'X',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: 'X',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: 'X',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: 'X',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "VERIFICACIÓN DE HISTORIAL ACADÉMICO":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: 'X',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: 'X',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: 'X',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: 'X',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: 'X',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "TRASLADO DE OPERADOR":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: 'X',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: 'X',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: 'X',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: 'X',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "TRÁMITE ACADÉMICO CON ABONO DE DINERO":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: 'X',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: 'X',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: 'X',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: 'X',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "TRÁMITE ACADÉMICO CON DEVOLUCIÓN DE DINERO":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: 'X',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: 'X',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: 'X',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: 'X',
                                SF: ' ',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "SALDO A FAVOR Y/O DEVOLUCIÓN DE DINERO":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: 'X',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: 'X',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: 'X',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: 'X',
                                MH: ' ',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "MATRÍCULA DE HONOR – DEVOLUCIÓN Y/O ABONO DE DINERO":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: 'X',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: 'X',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: 'X',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: 'X',
                                AD: ' ',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                case "APROBACIÓN DE DOBLE PROGRAMA DE PREGRADO":
                    switch (datainf.IdWorking) {
                        case "PRESENCIAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: 'X',
                                VM: ' ',
                                DM: ' ',
                                PJ: 'X',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: 'X',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "VIRTUAL":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: 'X',
                                DM: ' ',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: 'X',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        case "DISTANCIA":
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: 'X',
                                PJ: ' ',
                                VJ: 'X',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: 'X',
                                TM: ' ',
                                Cantidad: ' ',
                            }

                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }

                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                        default:
                            var dataDB = {
                                DD: today.getDate(),
                                MM: today.getMonth() + 1,
                                AAAA: today.getFullYear(),
                                NOMBRE_PROGRAMA: datainf.IdProgram,
                                NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                                NUM_DOCUMENTO: datainf.IdDocument,
                                CODIGO_ESTUDIANTIL: datainf.IdBanner,
                                PM: ' ',
                                VM: ' ',
                                DM: ' ',
                                PJ: ' ',
                                VJ: ' ',
                                CJ: ' ',
                                CM: ' ',
                                CP: ' ',
                                GC: ' ',
                                GM: ' ',
                                GQ: ' ',
                                CA: ' ',
                                RC: ' ',
                                RA: ' ',
                                RI: ' ',
                                RD: ' ',
                                PC: ' ',
                                AC: ' ',
                                CC: ' ',
                                CD: ' ',
                                GV: ' ',
                                RE: ' ',
                                RP: ' ',
                                RS: ' ',
                                SR: ' ',
                                VH: ' ',
                                TS: ' ',
                                TE: ' ',
                                TA: ' ',
                                TD: ' ',
                                SF: ' ',
                                MH: ' ',
                                AD: 'X',
                                TM: ' ',
                                Cantidad: ' ',
                            }
                            var InfData = {
                                reference: refFrom,
                                codPdf: refPDF,
                                dataProcedure: dataDB
                            }
                            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                            break;
                    }
                    break;
                default:
                    var dataDB = {
                        DD: today.getDate(),
                        MM: today.getMonth() + 1,
                        AAAA: today.getFullYear(),
                        NOMBRE_PROGRAMA: datainf.IdProgram,
                        NOMBRE_PERSONA: datainf.IdNombres + ' ' + datainf.IdApellidosS,
                        NUM_DOCUMENTO: datainf.IdDocument,
                        CODIGO_ESTUDIANTIL: datainf.IdBanner,
                        PM: ' ',
                        VM: ' ',
                        DM: ' ',
                        PJ: ' ',
                        VJ: ' ',
                        CJ: ' ',
                        CM: ' ',
                        CP: ' ',
                        GC: ' ',
                        GM: ' ',
                        GQ: ' ',
                        CA: ' ',
                        RC: ' ',
                        RA: ' ',
                        RI: ' ',
                        RD: ' ',
                        PC: ' ',
                        AC: ' ',
                        CC: ' ',
                        CD: ' ',
                        GV: ' ',
                        RE: ' ',
                        RP: ' ',
                        RS: ' ',
                        SR: ' ',
                        VH: ' ',
                        TS: ' ',
                        TE: ' ',
                        TA: ' ',
                        TD: ' ',
                        SF: ' ',
                        MH: ' ',
                        AD: ' ',
                        TM: ' ',
                        Cantidad: ' ',
                    }
                    var InfData = {
                        reference: refFrom,
                        codPdf: refPDF,
                        dataProcedure: dataDB
                    }
                    this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'PQRS/ProcessProcedureByPQRS/', InfData, config)
                    break;
            }
        } catch (error) {
            this.availabilityMessage = false;
            console.log(error);
        };
        return this.availabilityMessage;
    },

    sendFormInsShortCourse: async function (store, datainf) {
        try {
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'ShortCourse/AddInscriptionShortCourse/', datainf, config);
        } catch (error) {
            this.availabilityMessage = false;
            console.log(error);
        };
        return this.availabilityMessage;
    },

    sendFormInscriptionTemp: async function (store, datainf) {
        try {
            var InfData = {
                accountName: '' + datainf.IdOperator,
                idDocumentType: datainf.IdDocType,
                nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                numDocument: datainf.IdDocument,
                doc_ExpeditionDate: datainf.IdDaySelect + "/" + datainf.IdMonthSelect + "/" + datainf.IdYearSelect,
                nameExpeditionDepartment: this.dataObjFind(store.state.StateList, datainf.IdState),
                nameExpeditionCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                namPerson: datainf.IdNombreP + ' ' + datainf.IdNombreS,
                lastNamePerson: datainf.IdApellidosP + ' ' + datainf.IdApellidosS,
                desContactInformationPhone: datainf.IdHomePhone,
                desContactInformationMobile: datainf.IdCelPhone,
                desContactInformationEmail: datainf.IdMail,
                utmSource: "",
                utmCampaign: datainf.Campaign,
                utmMedium: "",
                utmContent: "",
            };
            this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Inscription/CreateSignUpPersonByZoho/', InfData, config);
        } catch (error) {
            this.availabilityMessage = false;
            console.log(error);
        };
        return this.availabilityMessage;
    },
    sendFormPQRSTemp: async function (store, datainf) {
        try {
            var InfData = {
                idDocumentType: datainf.IdDocType,
                nameDocumentType: this.dataObjFind(store.state.DocTypesList, datainf.IdDocType),
                numDocument: datainf.IdDocument,
                namPerson: datainf.IdNombres,
                lastNamePerson: datainf.IdApellidosS,
                idBanner: datainf.IdBanner,
                desContactInformationPhone: datainf.IdHomePhone,
                desContactInformationMobile: datainf.IdCelPhone,
                desContactInformationEmail: datainf.IdMail,
                nameResidenceCountry: this.dataObjFind(store.state.CountriesList, datainf.IdCountry),
                nameResidenceState: this.dataObjFind(store.state.StateList, datainf.IdState),
                nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                idBond: datainf.IdBond,
                nameBond: this.dataObjFind(store.state.BondsList, datainf.IdBond),
            };
            this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'PQRS/CreatePersonByPQRS', InfData, config);
        } catch (error) {
            this.availabilityMessage = false;
            console.log(error);
        };
        return this.availabilityMessage;
    },
    sendUpdloadFile: async function (store, file, module, iduser) {
        try {
            var availabilityMessageFile = new Array()
            for (var i = 0; i < file.length; i++) {
                let formData = new FormData()
                formData.append('file', file[i].filedata)
                let availabilityMSF = await axios.post(store.state.ApiIbero.WSUtilitary + 'Utilities/UploadFile?Nam_Module=' + module + '&Id_FilePerson=' + iduser, formData, configFile)
                availabilityMessageFile.push({ idDocument: file[i].idFileModule, idUserSign: file[i].idDetailUser, wsDocument: availabilityMSF })
            }
            this.availabilityMessage = availabilityMessageFile
        } catch (error) {
            this.availabilityMessage = false;
            console.log(error);
        };
        return this.availabilityMessage;
    },
    sendUpdloadFileWithName: async function (store, file, module, iduser) {
        try {
            var availabilityMessageFile = new Array()
            for (var i = 0; i < file.length; i++) {
                let formData = new FormData()
                formData.append('file', file[i].filedata)
                let availabilityMSF = await axios.post(store.state.ApiIbero.WSUtilitary + 'Utilities/UploadFileWithName?Nam_Module=' + module + '&Id_FilePerson=data' + i, formData, configFile)
                availabilityMessageFile.push({ idDocument: file[i].idFileModule, idUserSign: file[i].idDetailUser, wsDocument: availabilityMSF })
            }
            this.availabilityMessage = availabilityMessageFile
        } catch (error) {
            this.availabilityMessage = false;
            console.log(error);
        };
        return this.availabilityMessage;
    },
    sendFormUpdate: async function (store, datainf) {
        try {
            var InfData = {
                idPerson: datainf.IdPerson,
                idBanner: datainf.IdBanner,
                idDocumentType: datainf.IdDocType,
                nameDocumentType: datainf.IdDocType,
                numDocument: datainf.IdDocument,
                namPerson: datainf.IdNombre,
                lastNamePerson: datainf.IdApellidos,
                resAddress: datainf.IdAddress,
                codResidenceDepartment: datainf.IdState,
                nameResidenceDepartment: this.dataObjFind(store.state.StateList, datainf.IdState),
                codResidenceCity: datainf.IdCity,
                nameResidenceCity: this.dataObjFind(store.state.CityList, datainf.IdCity),
                idUpdatedBy: datainf.idUpdatedBy,
                nameResidenceNeighborhood: datainf.IdAddress,
                termsConditions: datainf.IdTermiCondi,
                infReceive: datainf.IdNewsLetter,
                idContactTypePhone: 1,
                desContactInformationPhone: datainf.IdHomePhone,
                idContactTypePhoneEmergency: 4,
                desContactInformationPhoneEmergency: datainf.IdCelPhone,
                idContactTypeMobile: 2,
                desContactInformationMobile: datainf.IdCelPhone,
                idContactTypeEmail: 3,
                desContactInformationEmail: datainf.IdMail,
                idPersonOperator: (datainf.IdTransferCenter.length >= 1) ? datainf.IdTransferCenter[0].idPersonOperator : 0,
                idOperator: (datainf.IdTransferCenter.length >= 1) ? datainf.IdTransferCenter[0].idOperator : 0,
                observation: 'Update by User',
                staActive: true,
            }
            this.availabilityMessage = await axios.put(store.state.ApiIbero.WSUtilitary + 'Person/UpdatePerson/', InfData, config)
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        };
        return this.availabilityMessage
    },
    callIberoLogin: async function (store, datainf) {
        try {
            this.LoginMessage = await axios.get(store.state.ConfigAuth.LoginUser, datainf, config);
        } catch (error) {
            this.LoginMessage = false;
            console.log(error);
        };
        return this.LoginMessage;
    },
    scrollToTop(x, y) {
        window.scrollTo(x, y);
    },
    getLocalIP: async function (store) {
        try {
            this.IPMSN = await axios.get(store.state.ApiIbero.LocalIP);
            axios.defaults.headers.common['CLIENT_IP'] = this.IPMSN.data.ip;
            axios.defaults.headers.common['CLIENT_SOURCE'] = 'PES';
        } catch (error) {
            this.IPMSN = false;
            console.log(error);
        };
        return this.IPMSN;
    },
    dataObjDate: function (InfDaT) {
        var d = new Date(InfDaT),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [day, month, year].join('/');
    },
    formatBytes(bytes, decimals) {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    sendEvent: async function (store, data) {
        try {
            this.availabilityMessage = await axios.post(store.state.ApiIbero.WSUtilitary + 'Event/AddRegistrationEvent', data);
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        };
        return this.availabilityMessage
    },

    generateSignature: async function (cadena) {
        try {
            this.availabilityMessage = await API.post("/payment/signature", { cadena });
        } catch (error) {
            this.availabilityMessage = false
            console.log(error)
        };
        return this.availabilityMessage
    },

    ObtenerPreguntasTestVocacional: async function (store) {
        try {
            this.availabilityMessage = await axios.get(store.state.ApiIbero.WSUtilitary + 'TestVocacional/TestVocacionalPreguntas');
        } catch (error) {
            this.availabilityMessage = false;
            console.log(error);
        }
        return this.availabilityMessage;
    },
    getCitiesList: function (store) {
        if (!store.state.CitiesList) {
            store.state.CitiesList = [];
        }
        axios.get(store.state.ApiIbero.WSParametric + 'City/GetAllCity', config).then(
            Response => {
                store.state.CitiesList.length = 0;
                for (var i = 0; i < Response.data.length; i++) {
                    store.state.CitiesList.push({ id: Response.data[i].codeCity, value: Response.data[i].nameCity })
                }
            }
        ).catch(e => {
            console.log(e);
        })
    },
    getSchoolsByCity: function (store, cityCode) {
        if (!store.state.SchoolList) {
            store.state.SchoolList = [];
        }
        if (!cityCode) {
            store.state.SchoolList.length = 0;
            return;
        }
        axios.get(store.state.ApiIbero.WSUtilitary + 'Schools/by-city/' + cityCode, config).then(
            Response => {
                store.state.SchoolList.length = 0;
                if (Response.data && Response.data.length) {
                    for (var i = 0; i < Response.data.length; i++) {
                        store.state.SchoolList.push({
                            id: Response.data[i].id,
                            value: Response.data[i].nombreOficial || Response.data[i].namSchool || ''
                        })
                    }
                }
            }
        ).catch(e => {
            console.log(e);
        })
    },
})
